export const ARCHIVE_DATA = [
  {
    id: 'kyron',
    category: 'IN DEVELOPMENT',
    name: 'KYRON',
    tagline: 'AI Agent for Zero-Friction Form Execution.',
    status: 'UNDER DEVELOPMENT',
    statusKey: 'BUILD',
    techStack: ['React 18', 'Tailwind CSS', 'FastAPI', 'Python Async', 'MongoDB', 'Playwright'],
    logo: '🤖',
    story: 'KYRON ek AI execution agent hai jo user ke master data aur intent ka use karke repetitive forms ko smart tareeke se fill aur validate karta hai.',
    vision: 'Next 3 years me KYRON ko multi-domain intelligent execution layer banana hai jo SAARKAAR ecosystem ke alag-alag ventures ko power kare.',
    workingModel: 'Voice/Text Input → Intent Detection → Master Profile Sync → Smart Field Mapping → Error Checks → Autofill + Confirmation',
    progressData: [
      { label: 'Core Architecture', value: 88 },
      { label: 'AI Intent Layer', value: 82 },
      { label: 'Automation Engine', value: 74 },
      { label: 'Profile Intelligence', value: 79 },
      { label: 'Production Readiness', value: 58 }
    ],
    miniStats: { lines: '52,000+', apis: '14', build: '2.1s' },
    techMatrix: [
      { name: 'Frontend', stack: 'React 18 + Tailwind + Animated UI', desc: 'High-clarity conversational workflow interface' },
      { name: 'Backend', stack: 'FastAPI + Python Async + Playwright', desc: 'Async orchestration and browser-level execution' },
      { name: 'AI Layer', stack: 'Whisper STT + Google Cloud TTS + LLM Intent', desc: 'Speech and intent intelligence loop' },
      { name: 'Data Layer', stack: 'MongoDB + Optional PostgreSQL', desc: 'Flexible profile storage with relational reporting option' }
    ],
    metrics: { lighthouse: '95', speed: '0.9s', latency: '42ms', env: 'Cloud Prototype', scalability: 'Modular horizontal scaling path defined' },
    businessImpact: 'Manual form process time ko significantly reduce karne ke liye engineered, especially repeated government/corporate workflows me.',
    challengesFaced: 'Complex forms, inconsistent input formats, aur contextual intent mapping ko reliable banana major challenge raha.',
    roadmap: 'Advanced automation hardening, broader integrations, aur production launch pipeline.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'KYRON — AI Agent for Zero-Friction Form Execution.' },
      { title: 'Status', content: 'Under Development: Join Us', ctaLabel: 'Join Us Form', ctaLink: '/portfolio/kyron#join-form' },
      { title: 'What is the Project', content: 'KYRON is an AI agent that auto-fills complex forms by using your master data, intent understanding, and smart field validation.' },
      { title: 'Problem Statement', content: 'Government aur enterprise forms repetitive, error-prone aur time-consuming hote hain, jisse users ka productivity loss hota hai.' },
      { title: 'Solution', content: 'KYRON data fetch karta hai, contextual mapping karta hai, missing values detect karta hai, aur final confirmation ke baad form execution complete karta hai.' },
      { title: 'Key Features', points: ['Master profile engine', 'AI field matching', 'Intent detection layer', 'Smart error detection', 'Automation-ready execution pipeline'] },
      { title: 'Technology Stack', points: ['Frontend: React 18, Tailwind CSS, Animated UI, Web Speech API', 'Backend: FastAPI, Python Async, Playwright', 'Database: MongoDB, optional PostgreSQL', 'AI: Whisper STT, Google Cloud TTS, LLM intent detection'] },
      { title: 'Deployment/Status', content: 'Under Development. Join Us: /portfolio/kyron#join-form' },
      { title: 'Future Vision (3 Years)', content: 'KYRON ko multi-domain digital execution agent banana, jahan users repetitive process work ko conversational interface se automate kar sakein.' },
      { title: 'Join Our Team', content: 'Interested in building this? Join us here.', ctaLabel: 'Join KYRON Team', ctaLink: '/portfolio/kyron#join-form' }
    ]
  },
  {
    id: 'dadisecrets',
    category: 'LIVE SYSTEMS',
    name: 'Dadi’s Secret',
    tagline: 'Organic Heritage Products, Digitally Delivered.',
    status: 'LIVE PRODUCTION',
    statusKey: 'LIVE',
    website: 'dadi-secrets-mall.vercel.app',
    url: 'https://dadi-secrets-mall.vercel.app',
    techStack: ['Next.js 14', 'Tailwind CSS', 'Node.js', 'Express', 'PostgreSQL', 'Redis'],
    logo: '🛍️',
    story: 'Dadi’s Secret ek organic products platform hai jahan achar, ghee, shahad jaise traditional products 100% natural promise ke saath sell hote hain.',
    vision: 'Agle 3 saal me local producers ko digital commerce ke through sustainable nationwide demand network dena.',
    workingModel: 'Product Discovery → Story-Driven UX → Cart Conversion → Order Pipeline → Inventory/Cache Sync → Fulfillment Feedback Loop',
    progressData: [{ label: 'Production Stability', value: 100 }],
    miniStats: { lines: '34,000+', apis: '9', build: '1.3s' },
    techMatrix: [
      { name: 'Frontend', stack: 'Next.js 14 + Tailwind + Framer Motion', desc: 'Fast SSR experience with premium brand feel' },
      { name: 'Backend', stack: 'Node.js + Express', desc: 'Reliable commerce and order logic' },
      { name: 'Data & Cache', stack: 'PostgreSQL + Redis', desc: 'Transactional integrity and high-speed retrieval' },
      { name: 'Deployment', stack: 'Vercel + Render + Upstash', desc: 'Separated production infrastructure for scale clarity' }
    ],
    metrics: { lighthouse: '99', speed: '0.4s', latency: '22ms', env: 'Vercel + Render', scalability: 'Edge delivery + independent backend scaling' },
    businessImpact: 'Local producers ko visibility aur direct customer access milta hai, jisse trust-led commerce grow hota hai.',
    challengesFaced: 'Organic sourcing authenticity aur digital inventory cadence ko aligned rakhna.',
    roadmap: 'Producer network expansion, subscription packs, aur quality trust layers.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'Dadi’s Secret — Organic Heritage Products, Digitally Delivered.' },
      { title: 'Status', content: 'Live. Visit Live: https://dadi-secrets-mall.vercel.app' },
      { title: 'What is the Project', content: 'Yeh ek organic commerce platform hai jo traditional natural products ko modern digital buying experience ke saath deliver karta hai.' },
      { title: 'Problem Statement', content: 'Local organic producers ke paas quality hoti hai, lekin unke paas scalable digital storefront aur trust-building visibility nahi hoti.' },
      { title: 'Solution', content: 'Platform curated natural products, transparent brand storytelling, aur smooth checkout flow ke through local producers ko direct market access deta hai.' },
      { title: 'Key Features', points: ['Organic product catalog', 'Traditional product storytelling', 'Fast checkout flow', 'Producer support model', 'Live digital storefront'] },
      { title: 'Technology Stack', points: ['Frontend: Next.js 14, Tailwind CSS, Framer Motion', 'Backend: Node.js, Express', 'Database: PostgreSQL', 'Cache: Redis', 'Deployment: Vercel, Render, Upstash'] },
      { title: 'Deployment/Status', content: 'Visit Live at https://dadi-secrets-mall.vercel.app' },
      { title: 'Future Vision (3 Years)', content: 'Verified organic producer network aur premium regional natural-products brand ecosystem develop karna.' }
    ]
  },
  {
    id: 'bookmythali',
    category: 'IN DEVELOPMENT',
    name: 'BookMyThali',
    tagline: 'Regional Tiffin Platform with Custom Thali Subscriptions.',
    status: 'UNDER DEVELOPMENT',
    statusKey: 'BUILD',
    techStack: ['HTML', 'CSS', 'JavaScript', 'Flask', 'MongoDB'],
    logo: '🍱',
    story: 'Book My Thali ek regional tiffin service platform hai jahan users apni पसंद ki thali customize kar sakte hain aur subscription-based meal plans le sakte hain.',
    vision: 'Agle 3 saal me local home cooks ke saath time-based personalized tiffin ecosystem build karna.',
    workingModel: 'Time-Based UI Signals → Search/Filter Engine → Cart Logic → Order Placement → Status Tracking Loop',
    progressData: [
      { label: 'Prototype UX', value: 72 },
      { label: 'Backend Logic', value: 68 },
      { label: 'Order Tracking', value: 61 },
      { label: 'Production Readiness', value: 36 }
    ],
    miniStats: { lines: '18,500+', apis: '6', build: '1.6s' },
    techMatrix: [
      { name: 'Frontend', stack: 'HTML + CSS (Theme based) + JavaScript', desc: 'Fast MVP interaction loops' },
      { name: 'Backend', stack: 'Flask', desc: 'Simple and rapid backend iteration' },
      { name: 'Database', stack: 'MongoDB', desc: 'Flexible catalog and order payload modeling' }
    ],
    metrics: { lighthouse: '91', speed: '1.1s', latency: '63ms', env: 'Prototype Cloud', scalability: 'Incremental service split planned' },
    businessImpact: 'Daily meal decision ko simple bana kar regional home-cook economy ko digitally empower karta hai.',
    challengesFaced: 'Time-based service windows aur customization logic ko clean UX ke saath align karna.',
    roadmap: 'Subscription rollout, home-cook onboarding, and regional operations launch.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'Book My Thali — Regional Tiffin Platform with Custom Thali Subscriptions.' },
      { title: 'Status', content: 'Under Development: Join Us', ctaLabel: 'Join Us Form', ctaLink: '/portfolio/bookmythali#join-form' },
      { title: 'What is the Project', content: 'Users apni पसंद ki thali customize karte hain, subscription choose karte hain, aur local home cooks ke time slots ke hisaab se meal service lete hain.' },
      { title: 'Problem Statement', content: 'Daily tiffin systems me personalization, timing consistency, aur local cook discoverability weak hoti hai.' },
      { title: 'Solution', content: 'Book My Thali time-based service logic, custom meal selection, aur subscription continuity ke through better regional tiffin experience create karta hai.' },
      { title: 'Key Features', points: ['Custom thali builder', 'Time-based home-cook service', 'Subscription model', 'Search & filters', 'Cart + order tracking'] },
      { title: 'Technology Stack', points: ['Frontend: HTML, CSS (theme based), JavaScript', 'Backend: Flask', 'Database: MongoDB'] },
      { title: 'Deployment/Status', content: 'Under Development. Join Us: /portfolio/bookmythali#join-form' },
      { title: 'Future Vision (3 Years)', content: 'Regional subscription meal grid ke saath multi-city home-cook network build karna.' },
      { title: 'Join Our Team', content: 'Interested in building this? Join us here.', ctaLabel: 'Join Book My Thali Team', ctaLink: '/portfolio/bookmythali#join-form' }
    ]
  },
  {
    id: 'annsetu',
    category: 'IN DEVELOPMENT',
    name: 'AnnSetu',
    tagline: 'Food Rescue and Community Support Booking Platform.',
    status: 'UNDER DEVELOPMENT',
    statusKey: 'BUILD',
    techStack: ['React 18', 'TypeScript', 'Vite', 'Node.js', 'Express', 'MongoDB', 'Socket.io'],
    logo: '🍲',
    story: 'Annsetu ek service-based booking platform hai jahan bacha hua khana zaruratmand logon tak pahunchaya jata hai aur beneficiaries baad me seva network ka hissa bante hain.',
    vision: 'Agle 3 saal me Annsetu ko scalable community food-relief network me evolve karna.',
    workingModel: 'Auth + Role Validation → Resource Event Intake → Realtime Dispatch Layer → Live Dashboard Update → Audit Trail',
    progressData: [
      { label: 'Core Platform', value: 80 },
      { label: 'Realtime Dashboard', value: 78 },
      { label: 'Security Middleware', value: 84 },
      { label: 'Operational Tooling', value: 64 }
    ],
    miniStats: { lines: '41,000+', apis: '18', build: '2.0s' },
    techMatrix: [
      { name: 'Frontend', stack: 'React 18 + TypeScript + Tailwind + shadcn/ui', desc: 'Type-safe, maintainable operations UI' },
      { name: 'Backend', stack: 'Node.js + Express + JWT + OTP', desc: 'Secure modular API orchestration' },
      { name: 'Realtime', stack: 'Socket.io', desc: 'Live dashboard updates and event synchronization' },
      { name: 'Security', stack: 'Role middleware + Zod + Audit Logs', desc: 'Governance and accountability by design' }
    ],
    metrics: { lighthouse: '94', speed: '0.8s', latency: '37ms', env: 'Production-Ready Dev', scalability: 'Realtime node scaling path defined' },
    businessImpact: 'Food waste reduce karte hue community-led support cycle create karta hai.',
    challengesFaced: 'Verified pickup-delivery workflows aur trust-based participation loop design karna.',
    roadmap: 'Ground-partner onboarding, realtime logistics refinement, and impact reporting.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'Annsetu — Food Rescue and Community Support Booking Platform.' },
      { title: 'Status', content: 'Under Development: Join Us', ctaLabel: 'Join Us Form', ctaLink: '/portfolio/annsetu#join-form' },
      { title: 'What is the Project', content: 'Annsetu surplus food donors ko needy users ke saath connect karta hai aur support receivers ko future contributors me convert karne ka community loop create karta hai.' },
      { title: 'Problem Statement', content: 'Large quantity me edible food waste hota hai jabki ground level par food access gap bana rehta hai.' },
      { title: 'Solution', content: 'Service booking, pickup coordination, role-based flow, aur community participation model se food redistribution efficient hoti hai.' },
      { title: 'Key Features', points: ['Food rescue requests', 'Role-based user flows', 'OTP + JWT security', 'Live dashboard updates', 'Audit logs'] },
      { title: 'Technology Stack', points: ['Frontend: React 18 + TypeScript + Vite + Tailwind + shadcn/ui', 'Backend: Node.js + Express', 'Database: MongoDB', 'Realtime: Socket.io', 'Security: JWT, OTP, role middleware, Zod'] },
      { title: 'Deployment/Status', content: 'Under Development. Join Us: /portfolio/annsetu#join-form' },
      { title: 'Future Vision (3 Years)', content: 'City-wise food rescue corridors aur measurable social impact intelligence platform build karna.' },
      { title: 'Join Our Team', content: 'Interested in building this? Join us here.', ctaLabel: 'Join Annsetu Team', ctaLink: '/portfolio/annsetu#join-form' }
    ]
  },
  {
    id: 'evenza',
    category: 'LIVE SYSTEMS',
    name: 'Evenza',
    tagline: 'Event & Marketing Operations Platform with AI Quotation Engine.',
    status: 'LIVE PRODUCTION',
    statusKey: 'LIVE',
    website: 'evenza.space',
    url: 'https://evenza.space',
    techStack: ['React', 'Material UI', 'Flask', 'MongoDB', 'OpenAI GPT', 'Vercel', 'DigitalOcean'],
    logo: '✨',
    story: 'Evenza ek event aur marketing platform hai jahan stalls, events, services ki details manage hoti hain aur AI-based quotation tool bhi integrated hai.',
    vision: '3-year horizon me AI-assisted event commerce and vendor orchestration layer build karna.',
    workingModel: 'Organizer Input → Event Context Modeling → AI Suggestions → Operator Decisions → Engagement Tracking',
    progressData: [{ label: 'Platform Readiness', value: 100 }],
    miniStats: { lines: '29,000+', apis: '11', build: '1.4s' },
    techMatrix: [
      { name: 'Frontend', stack: 'React + Material UI', desc: 'Operator-friendly management interfaces' },
      { name: 'Backend', stack: 'Flask', desc: 'Lightweight intelligence orchestration' },
      { name: 'AI Layer', stack: 'OpenAI GPT', desc: 'Assisted planning and recommendation support' },
      { name: 'Deployment', stack: 'Vercel + DigitalOcean', desc: 'Fast frontend + controlled backend hosting' }
    ],
    metrics: { lighthouse: '97', speed: '0.6s', latency: '31ms', env: 'Vercel + DigitalOcean', scalability: 'Container scaling path active' },
    businessImpact: 'Event planning aur pricing proposal process ko faster aur smarter banata hai.',
    challengesFaced: 'Different event categories ke liye AI quotation quality ko reliable rakhna.',
    roadmap: 'Quotation intelligence enhancement, vendor APIs, and event commerce analytics.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'Evenza — Event & Marketing Operations Platform with AI Quotation Engine.' },
      { title: 'Status', content: 'Live. Visit Live: https://evenza.space' },
      { title: 'What is the Project', content: 'Event stakeholders ke liye listings, stall/service details, updates, aur AI-driven quotation generation ek hi platform par available hai.' },
      { title: 'Problem Statement', content: 'Event planning me pricing, service discovery, aur quotation process fragmented hone ke karan execution slow hota hai.' },
      { title: 'Solution', content: 'Evenza centralized event updates, vendor-service management, aur AI quotation tool se planning aur negotiation cycles ko accelerate karta hai.' },
      { title: 'Key Features', points: ['Event/stall/service detail management', 'AI-based quotation tool', 'Marketing-ready listing flow', 'Operator dashboard'] },
      { title: 'Technology Stack', points: ['Frontend: React, Material UI', 'Backend: Flask', 'Database: MongoDB', 'AI: OpenAI GPT', 'Deployment: Vercel + DigitalOcean'] },
      { title: 'Deployment/Status', content: 'Visit Live at https://evenza.space' },
      { title: 'Future Vision (3 Years)', content: 'AI-native event pricing and vendor discovery infrastructure as a scalable event commerce layer.' }
    ]
  },
  {
    id: 'bookmygadi',
    category: 'LIVE SYSTEMS',
    name: 'BookMyGadi',
    tagline: 'Local Full-Day Vehicle Booking, Digitally Simplified.',
    status: 'LIVE',
    statusKey: 'LIVE',
    website: 'bookmygadi.lovable.app',
    url: 'https://bookmygadi.lovable.app',
    techStack: ['Web Platform', 'API Matching Engine', 'Booking Logic', 'Live Deployment'],
    logo: '🚗',
    story: 'BookMyGadi ek local gaadi booking system hai jahan user time ke hisaab se gaadi reserve karke pure din ke usage plan ko manage kar sakta hai.',
    vision: '3-year target: local booking se intelligent mobility orchestration platform tak evolve karna.',
    workingModel: 'Ride Request Intake → Smart Booking Algorithm → Driver Eligibility Match → Assignment Dispatch → Trip Lifecycle Tracking',
    progressData: [{ label: 'Live Service Reliability', value: 100 }],
    miniStats: { lines: '26,000+', apis: '8', build: '1.7s' },
    techMatrix: [
      { name: 'Platform', stack: 'Web-based Booking Interface', desc: 'Low-friction demand capture' },
      { name: 'Core Logic', stack: 'API-driven Matching Engine', desc: 'Driver assignment by demand context' },
      { name: 'Hosting', stack: 'lovable.app', desc: 'Live operational deployment' }
    ],
    metrics: { lighthouse: '93', speed: '0.9s', latency: '49ms', env: 'lovable.app', scalability: 'Service decomposition path available' },
    businessImpact: 'Traditional offline booking ko structured digital reservation workflow me convert karta hai.',
    challengesFaced: 'Day-wise availability, assignment logic, aur local demand spikes ko stable rakhna.',
    roadmap: 'AI route optimization aur smarter dispatch intelligence.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'BookMyGadi — Local Full-Day Vehicle Booking, Digitally Simplified.' },
      { title: 'Status', content: 'Live. Visit Live: https://bookmygadi.lovable.app' },
      { title: 'What is the Project', content: 'Yeh platform local users ko day-based vehicle reservation deta hai jisse unki full-day mobility plan digital tareeke se manage hoti hai.' },
      { title: 'Problem Statement', content: 'Offline local vehicle booking me transparency, confirmation, aur time-slot reliability ka issue hota hai.' },
      { title: 'Solution', content: 'BookMyGadi smart booking algorithm aur driver assignment logic ke saath request-to-ride flow ko digital and predictable banata hai.' },
      { title: 'Key Features', points: ['Day-based reservation', 'Time-slot booking flow', 'Driver assignment logic', 'Smart booking algorithm', 'Future AI route optimization'] },
      { title: 'Technology Stack', points: ['Frontend: Web-based booking interface', 'Backend: API-based matching logic', 'Hosting: bookmygadi.lovable.app'] },
      { title: 'Deployment/Status', content: 'Visit Live at https://bookmygadi.lovable.app' },
      { title: 'Future Vision (3 Years)', content: 'AI route optimization and regional fleet orchestration capabilities add karna.' }
    ]
  },
  {
    id: 'kora',
    category: 'LIVE SYSTEMS',
    name: 'Kora',
    tagline: 'Custom Gig Marketplace for Jobs, Volunteers, and Services.',
    status: 'LIVE',
    statusKey: 'LIVE',
    website: 'zynto.in',
    url: 'https://zynto.in',
    techStack: ['React', 'FastAPI', 'PostgreSQL', 'Capacitor'],
    logo: '🧠',
    story: 'KORA ek gig marketplace platform hai jahan users custom posts create karte hain—job, volunteer request, ya service requirement ke liye—and complete profile + skills ke saath hiring pipeline control karte hain.',
    vision: 'Agle 3 saal me KORA ko trusted skill-intelligence driven hiring and service orchestration marketplace banana.',
    workingModel: 'User Profile + Skills → Custom Post Creation → Candidate Discovery → Application Management → Hiring/Service Decision',
    progressData: [{ label: 'Cross-Platform Delivery', value: 100 }],
    miniStats: { lines: '47,000+', apis: '16', build: '1.9s' },
    techMatrix: [
      { name: 'Frontend', stack: 'React', desc: 'Composable interface system for web-first UX' },
      { name: 'Backend', stack: 'FastAPI', desc: 'High-performance REST service architecture' },
      { name: 'Database', stack: 'PostgreSQL', desc: 'Relational modeling and transactional confidence' },
      { name: 'Mobile Layer', stack: 'Capacitor', desc: 'Cross-platform deployment without backend duplication' }
    ],
    metrics: { lighthouse: '96', speed: '0.7s', latency: '35ms', env: 'Live Cloud', scalability: 'API-first horizontal scaling strategy' },
    businessImpact: 'Localized opportunities aur services ke liye structured digital discovery and application control enable karta hai.',
    challengesFaced: 'Multiple post types ke liye consistent workflow aur role-based pipeline controls maintain karna.',
    roadmap: 'Recommendation engine, trust-scoring, and expanded cross-platform adoption.',
    detailedSections: [
      { title: 'Project Name & Tagline', content: 'KORA — Custom Gig Marketplace for Jobs, Volunteers, and Services.' },
      { title: 'Status', content: 'Live. Visit Live: https://zynto.in' },
      { title: 'What is the Project', content: 'Users custom job/service/volunteer posts create karte hain, profile + skills showcase karte hain, aur application-hiring process ko platform se manage karte hain.' },
      { title: 'Problem Statement', content: 'Local and niche hiring/service requests ke liye flexible post formats aur end-to-end control usually available nahi hota.' },
      { title: 'Solution', content: 'KORA customizable posting, role-based profile visibility, and structured application management ke through complete gig workflow provide karta hai.' },
      { title: 'Key Features', points: ['Custom post creation', 'Skill profile showcase', 'Hiring/application control panel', 'Volunteer + job + service workflow', 'Cross-platform delivery'] },
      { title: 'Technology Stack', points: ['Frontend: React', 'Backend: FastAPI', 'Database: PostgreSQL', 'Mobile: Capacitor', 'Architecture: REST API design with relational modeling'] },
      { title: 'Deployment/Status', content: 'Visit Live at https://zynto.in' },
      { title: 'Future Vision (3 Years)', content: 'AI-assisted matching, trust ranking, and region-aware gig marketplace expansion.' }
    ]
  }
]

export const ARCHIVE_DATA_BY_ID = ARCHIVE_DATA.reduce((acc, project) => {
  acc[project.id] = project
  return acc
}, {})

export const buildProjectDetailFromArchive = (project) => {
  if (!project) return null

  const featureContent = (project.detailedSections || [])
    .find((section) => section.title.startsWith('7)'))?.content

  const problemContent = (project.detailedSections || [])
    .find((section) => section.title.startsWith('3)'))?.content

  const solutionContent = (project.detailedSections || [])
    .find((section) => section.title.startsWith('5)'))?.content

  return {
    id: project.id,
    title: project.name,
    tagline: project.tagline,
    description: project.story,
    status: project.status,
    badge: project.category,
    category: project.category,
    timeline: project.roadmap,
    live_link: project.url,
    vision: project.vision,
    problem_statement: problemContent || project.challengesFaced,
    solution: solutionContent || project.workingModel,
    tech_stack: project.techStack || [],
    features: featureContent ? [featureContent] : [],
    archive_sections: project.detailedSections || []
  }
}